module.exports = __webpack_public_path__ + "static/customers-417def8b98b56f35a79b0f07c01573b1.png";